import moment from "moment";

export const checkIsDateToday = (date) => date.isSame(moment(), "date");